<template>
  <a-card title="Kegiatan">
    <a-button v-if="getAuth.divisi[0] == 'HRD' && data.profile.status=='Aktif'" slot="extra" @click="handleModalEdit()">Ubah Data</a-button>
    <a-row>
      <a-col :xs="{ span: 24}" :lg="{ span: 12 }">
        <div class="m-bottom">
          <h4 class="m-remove">Tanggal Mulai</h4>
          <span class="m-text-medium" v-if="data.kegiatan">
            {{moment(data.kegiatan.tgl_mulai).format("DD-MM-YYYY")}}
          </span>
        </div>
        <div class="m-bottom">
          <h4 class="m-remove">Unit Kegiatan</h4>
          <span class="m-text-medium" v-if="data.kegiatan" >{{data.kegiatan.unit_kegiatan}}</span>
        </div>
        <div class="m-bottom">
          <h4 class="m-remove">Pembimbing</h4>
          <span class="m-text-medium" v-if="data.kegiatan">{{data.kegiatan.pembimbing}} - {{data.kegiatan.nama_pembimbing}}</span>
        </div>
      </a-col>
      <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
        <div class="m-bottom">
          <h4 class="m-remove">Tanggal Selesai</h4>
          <span class="m-text-medium" v-if="data.kegiatan">
            {{moment(data.kegiatan.tgl_selesai).format("DD-MM-YYYY")}}
          </span>
        </div>
        <div class="m-bottom">
          <h4 class="m-remove">Jenis Kegiatan</h4>
          <span class="m-text-medium" v-if="data.kegiatan">{{data.kegiatan.jenis_kegiatan}}</span>
        </div>
        <div class="m-bottom">
          <h4 class="m-remove">Non Diclosure Agreement</h4>
          <a-button size="small" type="primary" @click="downloadFile" :loading="loadingviewDoc">View Document</a-button>
        </div>
      </a-col>
    </a-row>

    <a-modal :width="800" title="Edit Kegiatan" :visible="visible" @cancel="handleCancel">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="btnLoading" @click="handleOk">Submit</a-button>
      </template>
      <a-form class="m-form" :form="form">
        <a-row :gutter="8">
          <a-col span="12">
            <a-form-item label="Tanggal Mulai">
              <a-date-picker
                class="w-full"
                :format="getDefaultDateFormat"
                v-decorator="['tanggal_mulai', {rules: [{required: true, message: 'Harus diisi!'}], initialValue: moment(data.kegiatan.tgl_mulai)}]"
              />
            </a-form-item>
            <a-form-item label="Unit Kegiatan">
              <a-select show-search :filter-option="filterOption" allowClear
                v-decorator="['unit_kegiatan', {rules: [{required: true, message: 'Harus diisi!'}], initialValue: data.kegiatan.unit_kegiatan}]"
                @change="changeUnit"
              >
                <a-select-option
                  v-for="items in data.master.divisi"
                  :key="items.divisi"
                >{{items.divisi}}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="pembimbing">
              <a-select show-search :filter-option="filterOption" allowClear v-decorator="['pembimbing', {rules: [{required: true, message: 'Harus diisi!'}], initialValue: data.kegiatan.pembimbing}]">
                <a-select-option
                  v-for="items in listpembimbing"
                  :key="items.tlc"
                >{{items.nama}} [{{items.tlc}}]</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col span="12">
            <a-form-item label="Tanggal Selesai">
              <a-date-picker
                class="w-full"
                :format="getDefaultDateFormat"
                v-decorator="['tanggal_selesai', {rules: [{required: true, message: 'Harus diisi!'}], initialValue: moment(data.kegiatan.tgl_selesai)}]"
              />
            </a-form-item>
            <a-form-item label="Jenis Kegiatan">
              <a-select show-search :filter-option="filterOption" allowClear v-decorator="['jenis_kegiatan', {rules: [{required: true, message: 'Harus diisi!'}],initialValue: data.kegiatan.jenis_kegiatan}]">
                <a-select-option key="Magang">Magang</a-select-option>
                <a-select-option key="Prakek Kerja Lapangan">Prakek Kerja Lapangan</a-select-option>
                <a-select-option key="Praktek Kerja">Praktek Kerja</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import _ from "lodash";

export default {
  props: ["data"],
  data() {
    return {
      visible: false,
      btnLoading: false,
      listpembimbing: [],
      loadingviewDoc: false
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {
    this.$store.dispatch("Fetch_Bank");
  },
  computed: {
    ...mapGetters(["getAuth", "getDefaultDateFormat"]),
    initial() {

        let initialData = {};
        if (! _.isEmpty(this.data.kegiatan)) {
            initialData = {
                  asal_univ: this.data.kegiatan.asal_univ,
                  bank: this.data.kegiatan.bank,
                  no_bpjs: this.data.kegiatan.no_bpjs,
                  no_ijazah: this.data.kegiatan.no_ijazah,
                  no_npwp: this.data.kegiatan.no_npwp,
                  no_rekening: this.data.kegiatan.no_rekening,
                  no_tenagakerja: this.data.kegiatan.no_tenagakerja,
                  pendidikan_terakhir: this.data.kegiatan.pendidikan_terakhir,
                  tahun_lulus: this.data.kegiatan.tahun_lulus
                }
        }
        return initialData ;

    }
  },
  methods: {
    moment,
    handleModalEdit() {
      this.listpembimbing = this.data.master.pembimbing.filter((item)=>{
        return item.divisi==this.data.kegiatan.unit_kegiatan
      })
      this.visible = true;
    },
    handleCancel() {
      this.form.resetFields();
      this.visible = false;
    },
    handleOk() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        this.confirmMessage("confirm-edit");
      });
    },
    submit() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        this.btnLoading = true;
        let postData = new FormData();

        postData.append("id_siswa", this.data.profile.id_siswa);
        postData.append("jenis_kegiatan", values.jenis_kegiatan);
        postData.append("unit_kegiatan", values.unit_kegiatan);
        postData.append("pembimbing", values.pembimbing);
        postData.append("tanggal_mulai", values.tanggal_mulai.format('YYYY-MM-DD'));
        postData.append("tanggal_selesai", values.tanggal_selesai.format('YYYY-MM-DD'));

        axios({
          method: "post",
          url: this.$serviceUrl + "internship/kegiatan",
          processData: false,
          data: postData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey
          }
        })
          .then(response => {
            this.displayMessage("success-edit");
            this.btnLoading = false;
            this.visible = false
            Event.$emit("fetching");
          })
          .catch(err => {
            this.btnLoading = false;
          });
      });
    },
    downloadFile(){
      // window.open(this.$serviceUrl + "internship/nda?id_siswa="+this.data.profile.id_siswa, "_blank");
      this.loadingviewDoc = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "internship/nda",
        responseType: "blob",
        params: {
          id_siswa: this.data.profile.id_siswa,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
      .then((response) => {
        let blob = new Blob([response.data], { type: "application/pdf" }),
          url = window.URL.createObjectURL(blob);
        window.open(url, "_blank");
        this.loadingviewDoc = false;
      })
      .catch((err) => {
        console.log(err)
        this.loadingviewDoc = false;
      });
    },
    changeUnit(val){
      this.$nextTick(() => {
        this.form.setFieldsValue({
          pembimbing: null,
        });
      })
      this.listpembimbing = this.data.master.pembimbing.filter((item)=>{
        return item.divisi==val
      })
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
  },
  mounted() {
    Event.$on("confirmMessageEdit", this.submit);
  },
  beforeDestroy() {
    Event.$off("confirmMessageEdit", this.submit);
  }
};
</script>

<style>
</style>
